export default __webpack_public_path__ + "static/media/dark_invoice_icon.fb6cad0b.svg";